export const availableLanguages = ['en', 'es', 'pt', 'ca'];
export const pathsNotAllowedRedirection = ['recuperar-password/', 'nuevo-login/', 'sso-redirect'];
